import { en, type ChromeMessages } from "./chrome_en.ts";

/** Catalan web app chrome. Unlisted keys stay English (product names and tokens). */
export const ca: ChromeMessages = {
  ...en,
  appTitle: "intEHRgrator — Banc de treball d'integració",
  copyPrompt: "Copia la indicació",
  copyPromptTitle: "Copia la indicació d'IA amb els fitxers incrustats",
  callAi: "Crida la IA",
  callAiTitle: "Crida la IA configurada amb eines de mapatge (noms MCP / API de l'agent)",
  aiMenuAria: "Ajuda d'IA",
  menuCopyPrompt: "Copia la indicació",
  menuCallAi: "Crida la IA",
  menuAiCredentials: "Configura les credencials d'IA…",
  menuEmbedFiles: "Incrusta els fitxers a la indicació",
  menuAttachFiles: "Adjunta fitxers al xat",
  menuBrowseUris: "Explora els URI (quan n'hi hagi)",
  menuAiCopyHeading: "copia/enganxa per a xat d'IA extern",
  menuAiOwnHeading: "La vostra IA",
  menuAiDesktopHeading: "Escriptori",
  menuLocalMcp: "Servidor MCP local…",
  localMcpTitle: "Servidor MCP local",
  localMcpIntro:
    "Inicieu o atureu el servidor que l'IDE fa servir per editar aquest llenç. Copieu la configuració als paràmetres MCP de l'IDE. Deixeu aquesta aplicació oberta.",
  localMcpRunning: "En marxa — un IDE s'hi pot connectar",
  localMcpStopped: "Aturat — els IDE no poden canviar aquest llenç",
  localMcpStart: "Inicia",
  localMcpStop: "Atura",
  localMcpUrlLabel: "URL de l'API d'agent",
  localMcpTokenLabel: "Token",
  localMcpNoToken: "Sense token (només loopback)",
  localMcpConfigLabel: "Configuració de l'IDE (mcp.json)",
  localMcpCopy: "Copia la configuració",
  localMcpCopied: "Configuració copiada",
  localMcpUnavailable: "El servidor d'escriptori no ha respost.",
  menuFile: "Fitxer",
  menuAi: "IA",
  importAi: "Importa suggeriments d'IA",
  exampleSets: "Conjunts d'exemples",
  exampleSetsTitle: "Carrega un conjunt d'exemples complet (origen, destinació, mapatge opcional) des d'URI del catàleg",
  exampleSetsMenuAria: "Tria un conjunt d'exemples",
  functions: "Funcions",
  functionsTitle: "Desa, carrega o contribueix funcions de Blockly; explora la biblioteca de funcions de GitHub",
  newProject: "Projecte nou",
  loadProject: "Carrega el projecte",
  saveAs: "Anomena i desa",
  exportProject: "Exporta el projecte",
  importProject: "Importa el projecte",
  betterForm: "Obre el formulari Better",
  betterFormTitle: "El renderitzador Better amb llicència roman en aquest navegador. Pugeu-lo al visor si encara no hi és.",
  help: "Ajuda",
  helpTitle: "Tutorial i informes d'incidències",
  helpMenuAria: "Menú d'ajuda",
  userTutorial: "Tutorial de l'usuari",
  reportBug: "Informa d'un error",
  requestFeature: "Sol·licita una funcionalitat",
  uiLanguageAria: "Idioma de la interfície",
  showSource: "Origen",
  source: "Origen",
  clickToMapAria: "Clic per mapar a Handlebars",
  clickToMapHtml:
    "Fes clic en un node de l'esquema d'origen o de la instància d'exemple per mapar-lo al bloc de Blockly seleccionat. Si hi ha seleccionat un bloc de text de codi (LANG = Handlebars) o un bloc de text Handlebars, el clic insereix un {{path}} de VMS-Hbs al cursor. Mantén premuda Maj per a {{#with}} / {{#each}} imbricats. Si no, el mode d'escolta omple el bloc de consulta d'origen que espera.",
  slideSourceAway: "Aparta l'Origen",
  handlebarsHint: "Inserció Handlebars a punt — fes clic en un node d'origen per a {{path}}; Maj+clic per a #with/#each imbricats.",
  schemaFormatsAria: "Formats d'esquema admesos",
  schemaFormatsHtml:
    "Admesos: JSON Schema, documents JSON o XML, mostres XSD i Web Template d'openEHR, Composition JSON o un .t.json de GitHub (els arquetips s'obtenen del mateix repositori).<br>Carrega des d'un fitxer local, una URL o ▾ → Des d'una plantilla de GitHub….",
  loadSchema: "Carrega l'esquema",
  schemaMenuAria: "Més maneres de carregar l'esquema",
  examples: "Exemples",
  exampleFormatsAria: "Formats d'exemple admesos",
  exampleFormatsHtml:
    "Admesos: fitxers d'instància JSON o XML.<br>Carrega un fitxer, una carpeta local, una carpeta de GitHub (▾) o un sol fitxer des d'una URL.",
  addExample: "+ Afegeix un exemple",
  exampleMenuAria: "Més maneres de carregar exemples",
  mappingEditors: "Editors de mapatge",
  undo: "Desfés",
  redo: "Refés",
  expandAll: "Desplega-ho tot",
  expandAllTitle: "Desplega tots els blocs imbricats",
  collapseAll: "Plega-ho tot",
  collapseAllTitle: "Plega tots els blocs imbricats",
  expandChildren: "Desplega els fills",
  collapseChildren: "Plega els fills",
  useCodedText: "Usa text codificat (DV_CODED_TEXT)",
  usePlainText: "Usa text simple (DV_TEXT)",
  followAgent: "Segueix l'agent",
  followAgentTitle: "Quan està actiu, desplaça el llenç principal fins als blocs que un agent acaba d'editar",
  openViewer: "Obre la finestra de visualització",
  openViewerTitle: "Obre la finestra de visualització: llenç en directe, llegenda d'agents i línia de temps de l'historial amb atribució",
  downloadJson: "Baixa JSON",
  downloadWorkspaceTitle: "Baixa el JSON complet de l'espai de treball Blockly (inclou les coordenades i la disposició dels blocs)",
  mappingViewsAria: "Vistes de text de l'editor de mapatge",
  mappingSpec: "Especificació de mapatge",
  specLayoutAria: "Opcions de vista de l'especificació",
  listView: "Vista de llista (totes les arrels)",
  tabbedView: "Vista per pestanyes (per arrel)",
  download: "Baixa",
  downloadSpecTitle: "Baixa el JSON complet de l'espai de treball Blockly",
  downloadSpecAria: "Baixa el JSON complet de l'espai de treball Blockly",
  upload: "Puja",
  uploadSpecTitle: "Puja un fitxer JSON de l'espai de treball Blockly",
  uploadSpecAria: "Puja un fitxer JSON de l'espai de treball Blockly",
  specEditorActionsAria: "Accions de l'editor d'especificació de mapatge",
  searchSpecTitle: "Cerca a l'especificació de mapatge",
  searchSpecAria: "Cerca a l'especificació de mapatge",
  copySpecTitle: "Copia l'especificació de mapatge",
  copySpecAria: "Copia l'especificació de mapatge",
  scriptEditorActionsAria: "Accions de l'editor de guió de conversió",
  searchScriptTitle: "Cerca al guió de conversió",
  searchScriptAria: "Cerca al guió de conversió",
  copyScriptTitle: "Copia el guió de conversió",
  copyScriptAria: "Copia el guió de conversió",
  downloadScriptAria: "Baixa el guió de conversió",
  testEditorActionsAria: "Accions de l'editor de resultat de prova",
  searchTestTitle: "Cerca al resultat de la prova",
  searchTestAria: "Cerca al resultat de la prova",
  copyTestTitle: "Copia el resultat de la prova",
  copyTestAria: "Copia el resultat de la prova",
  downloadTestAria: "Baixa el resultat de la prova de conversió",
  markWarned: "Marca els opcionals amb avís",
  markWarnedTitle: "Marca els arbres de bastida opcionals sense mapatge que mostren un avís de restricció",
  deleteMarked: "Suprimeix els marcats",
  deleteMarkedTitle: "Suprimeix del llenç els nodes marcats i els seus fills",
  undoHistoryHint: "Consell: obre el llenç (observador) per a la línia de temps completa de l'agent i l'historial amb atribució.",
  undoLastEdit: "Desfés la darrera edició del llenç.",
  redoLastEdit: "Refés l'edició del llenç.",
  railTarget: "Esquema de destinació",
  railTargetTitle: "Esquema de destinació",
  railScripts: "Guions",
  railScriptsTitle: "Guions de conversió generats",
  railTestTitle: "Proves de conversió",
  targetPreviews: "Destinació i previsualitzacions",
  targetFormatsAria: "Formats de destinació admesos",
  targetFormatsHtml:
    "Admesos: OPT/OPT2 d'openEHR, Web Template, JSON Schema, XML Schema (XSD), ADL, plantilles lliures o un .t.json de GitHub (els arquetips s'obtenen del mateix repositori).<br>Tria una destinació i un mapa de context per defecte alhora. ▾ també ofereix fitxer, URL, GitHub i actualització no destructiva.",
  loadTarget: "Carrega la destinació i el mapa de context per defecte",
  loadTargetTitle: "Carrega una destinació i tria un mapa de context per defecte",
  targetMenuAria: "Més maneres de carregar la destinació",
  modelLanguageAria: "Idioma de l'ontologia del model de destinació",
  scriptFormatsAria: "Formats de guió de conversió",
  scriptFormatsHtml:
    "La previsualització del mapatge interpreta el mapatge sense generar cap guió. Guions de conversió (fins ara): TypeScript, Java, Handlebars, XQuery i Go Template. TypeScript, Handlebars, Go Template i XQuery també s'executen a la prova de conversió. Java genera una classe Archie però no s'executa al web app. En destinacions openEHR, la instància JSON o XML tria com XQuery serialitza la composició.<br>El botó Baixa de l'editor de guions desa el guió generat. El botó Baixa superposat a la prova de conversió desa aquella instància.",
  mappingPreview: "Previsualització del mapatge",
  instance: "Instància",
  instanceTitle: "Forma d'instància openEHR desitjada. L'exportació XQuery i la prova usen aquesta serialització.",
  jsonInstance: "Instància JSON",
  xmlInstance: "Instància XML",
  slideTargetAway: "Aparta Destinació i previsualitzacions",
  tabTargetSchema: "Esquema de destinació",
  tabScripts: "Guions de conversió generats",
  tabTest: "Proves de conversió",
  generatedScripts: "Guions de conversió generats",
  downloadScriptTitle: "Baixa el guió de conversió",
  testRuns: "Proves de conversió",
  validateAs: "Valida com a",
  validateTitle: "Predefinició del deserialitzador JSON d'ehrtslib per a la validació de la plantilla",
  hybrid: "Híbrid (permissiu)",
  defaultMode: "Per defecte",
  compact: "Compacte",
  canonicalStrict: "Canònic estricte",
  terse: "Concís",
  runTest: "Executa la prova",
  autoplay: "▶ Reproducció automàtica",
  pause: "⏸ Pausa",
  downloadTestTitle: "Baixa el resultat de la prova de conversió",
  ready: "A punt",
  loadSchemaEmpty: "Carrega un fitxer d'esquema.",
  selectExampleTab: "Selecciona una pestanya d'exemple.",
  addExamplesEmpty: 'Afegeix instàncies d\'exemple per activar "Proves de conversió" a Destinació i previsualitzacions',
  loadTargetEmpty: "Carrega un esquema o una plantilla de destinació.",
  statusNoTarget: "Cap destinació",
  statusTarget: "Destinació: {id}",
  statusScript: "Guió: {name}",
  statusNoExample: "Cap exemple",
  statusExample: "Exemple: {name}",
  statusUnmapped: "{n} obligatoris sense mapatge",
  unsavedChanges: "canvis sense desar",
  autosavedAt: "desat automàticament a les {time}",
  functionsIntroHtml:
    "Desa una funció de Blockly (definició + taules de decisió) al disc, carrega'n una en aquest mapatge o explora la biblioteca de funcions de GitHub. Contribuir obre una incidència de revisió: no es fusiona automàticament.",
  onThisCanvas: "En aquest llenç",
  loadFromDisk: "Carrega des del disc…",
  functionLibrary: "Biblioteca de funcions",
  catalogUrl: "URL del catàleg",
  loadCatalog: "Carrega el catàleg",
  close: "Tanca",
  nameInUse: "El nom ja està en ús",
  cancel: "Cancel·la",
  replace: "Substitueix",
  rename: "Canvia el nom",
  contributeTitle: "Contribuir una funció",
  contributeIntroHtml:
    "Obre una incidència de GitHub a <code>regionstockholm/intehrgrator</code> amb la teva descripció i la definició de la funció. Els mantenidors la revisen manualment.",
  functionName: "Funció:",
  descriptionRequired: "Descripció (obligatòria)",
  contributePlaceholder: "Què retorna, configuració regional, taula de decisió, paràmetres…",
  needGithubHtml:
    'Necessites un compte de GitHub? <a id="function-contribute-signup" href="https://github.com/signup" target="_blank" rel="noopener noreferrer">Crea un compte</a> o <a id="function-contribute-login" href="https://github.com/login" target="_blank" rel="noopener noreferrer">inicia la sessió</a> i després envia.',
  openGithubIssue: "Obre una incidència de GitHub",
  saveAsIntro: "Desa l'espai de treball actual amb un nom que podràs carregar més endavant.",
  projectName: "Nom del projecte",
  projectNamePlaceholder: "El meu projecte d'integració",
  save: "Desa",
  loadProjectTitle: "Carrega el projecte",
  loadProjectIntro: "Selecciona un espai de treball desat. En carregar se substitueix el projecte actual.",
  loadFromUrl: "Carrega des d'una URL",
  loadUrlHint: "Enganxa una URL https. Les pàgines de fitxer de GitHub es converteixen en contingut en brut.",
  recentUrls: "URL recents",
  load: "Carrega",
  jointTitle: "Carrega la destinació i el mapa de context per defecte",
  jointIntroHtml:
    "Tria una destinació i un mapa de context per defecte alhora. En confirmar es construeix l'<strong>esquelet de plantilla</strong> i els <strong>punts per defecte</strong>. <strong>Nou</strong> carrega la destinació només a la pestanya Esquema de destinació, perquè puguis agafar fitxes i valors i després prémer Aplica al bloc del llenç.",
  targetLegend: "Destinació",
  noTargetYet: "Encara no hi ha cap destinació seleccionada.",
  fromFile: "Des d'un fitxer…",
  useLoadedTarget: "Usa la destinació carregada",
  targetUrl: "URL de destinació",
  fetchUrl: "Obtén la URL",
  mapLegend: "Mapa de context per defecte",
  factoryMapHtml: "Fàbrica openEHR (<code>defaults_openEHR_1</code>)",
  keepMap: "Conserva el mapa que ja és al llenç",
  newMap: "Nou (buit) — primer l'esquema de destinació i després Aplica",
  browsedFile: "Fitxer navegat",
  browseMap: "Navega pel fitxer de mapa…",
  loadAndScaffold: "Carrega i construeix l'esquelet",
  loadIntoSchema: "Carrega a l'esquema de destinació",
  refreshReport: "Informe d'actualització",
  copyMergePrompt: "Copia la indicació de fusió",
  aiCredentialsTitle: "Credencials d'IA",
  aiCredentialsIntroHtml:
    'Punt de xat compatible amb OpenAI, opcional, perquè <strong>Crida la IA</strong> pugui mapar des del web app. Les credencials es queden només en aquest navegador, no al paquet del projecte. <strong>Crida la IA</strong> pot usar les mateixes eines de mapatge que MCP / l\'API HTTP de l\'agent (<code>map_slot</code>, <code>import_suggestions</code>, <code>run_test</code>, …). Un IDE assistit per IA amb MCP local continua sent una via separada i plenament vàlida. Pàgines pas a pas per a les claus: <a href="https://github.com/regionstockholm/intehrgrator/blob/main/docs/AI_CREDENTIALS.md" target="_blank" rel="noopener noreferrer" id="ai-credentials-guide">Credencials de Crida la IA</a>.',
  provider: "Proveïdor",
  customEndpoint: "Punt de connexió propi compatible amb OpenAI",
  getApiKey: "Obtén una clau d'API",
  providerDocs: "Documentació del proveïdor",
  endpoint: "Punt de connexió",
  apiKey: "Clau d'API",
  model: "Model",
  clear: "Esborra",
  defaultsTitle: "Mapa de context per defecte",
  defaultsIntro: "Carrega un mapa desat, navega per un fitxer o una URL, baixa l'únic mapa de context per defecte o desa el mapa actual del llenç amb un nom.",
  browseFile: "Navega pel fitxer…",
  loadUrlBtn: "Carrega la URL",
  downloadFile: "Baixa el fitxer…",
  saveAsEllipsis: "Anomena i desa…",
  saveDefaultsTitle: "Desa el mapatge de context per defecte com a",
  saveDefaultsIntro: "Desa el mapatge de context per defecte actual amb un nom que podràs triar més endavant.",
  nameLabel: "Nom",
  hardcodeTitle: "Fixa una entrada del mapatge de context per defecte",
  hardcodeIntroHtml:
    "Tria una clau del mapa per <strong>incorporar-la</strong> al llenç. Cada cerca <code>get defaults key …</code> d'aquesta clau se substitueix per una còpia del valor d'aquest mapa de context per defecte. Després, aquestes ranures ja no llegeixen l'argument <code>defaults</code> en temps de conversió: fan servir el bloc fixat. El mapa de context per defecte en si no canvia, perquè puguis fixar altres claus més endavant o conservar l'entrada per a les cerques que quedin.",
  importAiTitle: "Importa suggeriments d'IA",
  importAiIntroHtml:
    "Enganxa el JSON del xat d'IA (un objecte en brut o un bloc <code>intehrgrator-suggestions</code>). La importació es valida contra el JSON Schema de suggeriments; els errors es queden visibles aquí i es poden copiar de nou cap a la IA.",
  suggestions: "Suggeriments",
  pasteClipboard: "Enganxa el porta-retalls",
  copyErrorsForAi: "Copia els errors per a la IA",
  copied: "Copiat",
  importAction: "Importa",
  notRecommended: "No ets a la versió recomanada",
  bleedingEdgeHtml:
    'Prefereixes experimentar? La compilació més recent (s\'actualitza amb cada canvi a <code>main</code>) és sempre a <a id="recommended-version-bleeding-edge-link" href="#">l\'arrel del lloc</a>.',
  newHereHtml:
    'Nou aquí? Llegeix el <a id="recommended-version-tutorial-link" href="#">tutorial</a> o el <a id="recommended-version-readme-link" href="#">README</a>.',
  dontShowAgain: "No tornis a mostrar això per a aquesta versió",
  dismiss: "Descarta",
  defaultsBlockAria: "Sobre el mapa de context per defecte",
  defaultsBlockHtml:
    "El <strong>mapa de context per defecte</strong> és la taula única del llenç que defineixes aquí. En <em>temps de conversió</em>, els guions de conversió generats el reben com a argument <code>defaults</code>, amb <strong>clau d'execució</strong> (<code>language</code>, <code>facility</code>, …). <code>maps_get(\"defaults\", runtimeKey)</code> les consulta. El codi d'execució pot combinar aquest conjunt amb valors per missatge, altres mapes amb nom i graelles de fulls: el mapa del llenç és la base reutilitzable, no literals fixats a cada ranura.<br>Les <strong>destinacions de bastida</strong> (fitxes) són només camins RM d'autoria, no claus de temps de conversió: <code>Class.attribute</code> (p. ex. <code>COMPOSITION.composer</code>, <code>EVENT_CONTEXT.health_care_facility</code>), camins d'ancestres i comodins (<code>*.language</code> il·lumina cada ranura d'idioma). Quan diverses encaixen a la mateixa ranura, guanya la fitxa més específica. Fitxes buides → una clau només d'execució que no il·lumina res. Les claus addicionals continuen disponibles per a cerques al mapa encara que no il·luminin cap ranura.<br>Confirma, <strong>Aplica el mapa de context per defecte</strong> o una actualització posterior de la destinació uneixen els <strong>punts per defecte</strong>. Els canvis de valor es veuen en directe a la prova. Una ranura ja mapada des de l'origen no se substitueix.<br>La carpeta obre la càrrega i el desament: tria un mapa desat en aquest navegador, navega per un fitxer JSON, carrega una URL, desa una còpia amb nom o baixa el mapa actual com a JSON per tornar-lo a pujar més endavant.",
  decisionBlockAria: "Sobre les taules de decisió",
  decisionBlockHtml:
    "La <strong>taula de decisió</strong> és una graella de regles amb nom a la pestanya Taules i fulls: columnes de condició (igualtat, indiferent <code>—</code>) i columnes de sortida (valors simples o fragments VMS-Mustache). La graella defineix els noms i els tipus de columna; les claus del mapa d'entrades d'aquest bloc es mantenen sincronitzades.<br>Connecta a la dreta un mapa d'entrades (claus = capçaleres de condició). El desplegable de sortida retorna una columna tipada (🔤 cadena, 🔢 nombre, ✓ booleà) o <em>totes les sortides</em> com a mapa (↦). Canviar aquest tipus pot desconnectar el bloc; amb Desfés i Refés al llenç es restaura.<br>La política d'encert (FIRST / UNIQUE / COLLECT) és a la pestanya Taules i fulls. Aplana els orígens imbricats dins el mapa d'entrades (o mitjançant variables) abans d'avaluar.",
  fromUrl: "Des d'una URL…",
  refreshFromFile: "Actualitza des d'un fitxer…",
  refreshFromUrl: "Actualitza des d'una URL…",
  noRecentUrls: "Encara no hi ha URL recents.",
  removeFromHistory: "Treu {url} de l'historial",
  enterUrl: "Introdueix una URL.",
  refreshKindFromUrl: "Actualitza {kind} des d'una URL",
  refreshUrlHint: "Torna a carregar aquest fitxer des d'una URL sense esborrar els mapatges del llenç. Els avisos llisten ranures o camins que potser ja no encaixen.",
  kindExample: "exemple",
  kindTarget: "destinació",
  kindSource: "origen",
  fromLocalFolder: "Des d'una carpeta local…",
  fromGithubFolder: "Des d'una carpeta de GitHub…",
  fromGithubTemplate: "Des d'una plantilla de GitHub…",
  loadSchemaFromUrl: "Carrega l'esquema des d'una URL",
  loadSchemaUrlHint: "JSON, XML, XSD o una plantilla .t.json de GitHub (els arquetips s'obtenen del mateix repositori). Les pàgines de fitxer de GitHub es converteixen en contingut en brut.",
  recentSchemaUrls: "URL d'esquema recents",
  githubTemplateTitle: "Carrega una plantilla openEHR des de GitHub",
  githubTemplateHint: "Enganxa una URL blob o raw de GitHub d'un .t.json de Better (o .adl / .opt). Els arquetips dependents es prenen de la mateixa branca del repositori.",
  githubTemplateOpenTitle: "Obre una plantilla openEHR des de GitHub",
  addExampleFromUrl: "Afegeix un exemple des d'una URL",
  addExampleUrlHint: "Instància JSON o XML. Les pàgines de fitxer de GitHub es converteixen en contingut en brut.",
  recentExampleUrls: "URL d'exemple recents",
  githubFolderTitle: "Afegeix exemples des d'una carpeta de GitHub",
  githubFolderHint: "Enganxa una URL d'arbre de GitHub d'una carpeta. Es carreguen tots els fitxers JSON i XML d'aquest camí.",
  loadTargetFromUrl: "Carrega la destinació des d'una URL",
  loadTargetUrlHint: "OPT, Web Template, JSON Schema o un .t.json de GitHub. Les pàgines de fitxer de GitHub es converteixen en contingut en brut.",
  recentTargetUrls: "URL de destinació recents",
  loadingCatalog: "Carregant el catàleg…",
  exampleSetsHeading: "Conjunts d'exemples",
  noExampleSets: "No hi ha conjunts d'exemples al catàleg",
  catalog: "Catàleg",
  bundledCatalog: "Catàleg de mostra inclòs",
  ehrtslibCatalog: "Catàleg ehrtslib (GitHub)…",
  loadCatalogFromUrl: "Carrega el catàleg des d'una URL…",
  catalogUrlPrompt: "URL JSON del catàleg de conjunts d'exemples",
  confirmLoadExampleSet: "Vols carregar aquest conjunt d'exemples? L'espai de treball actual se substituirà. Els canvis sense desar es poden perdre.",
  confirmNewProject: "Vols començar un projecte nou? L'espai de treball actual es buidarà. Els canvis sense desar es poden perdre.",
  confirmNewEmpty: "Vols començar un projecte buit?",
  confirmLoadProject: "Vols carregar aquest projecte? L'espai de treball actual se substituirà.",
  noSavedProjects: "Encara no hi ha projectes desats. Usa Anomena i desa o espera el desament automàtic.",
  lastAutosave: "Darrer desament automàtic",
  savedProject: "Projecte desat",
  defaultsUnavailable: "El catàleg de valors per defecte no està disponible: {detail}",
  noSavedMaps: "Encara no hi ha mapatges de context per defecte desats. Usa Anomena i desa, Baixa, Navega pel fitxer o una URL.",
  savedMap: "Mapa desat",
  noHardcodeEntries: "El mapatge de context per defecte encara no té entrades per fixar.",
  selectedFile: "Seleccionat: {name}",
  usingLoaded: "S'està usant el carregat: {name}",
  fetchedFile: "Obtingut: {name}",
  browsedFileLabel: "Fitxer navegat: {name}",
  pasteTargetUrl: "Enganxa primer una URL de destinació.",
  popupBlockedSvg: "Finestra emergent bloquejada: s'ha baixat un SVG en el seu lloc.",
  popupBlockedEmpty: "Finestra emergent bloquejada i el llenç és buit.",
  openedObserver: "S'ha obert l'observador de l'agent / la instantània del llenç.",
  betterPopupBlocked: "No s'ha pogut obrir el visor de formularis Better. Permeteu les finestres emergents per a aquest lloc.",
  schemaMismatch: "Discrepància d'esquema:",
  conversionFailed: "La conversió ha fallat:",
  templateValidation: "Validació de la plantilla:",
  noWorkspace: "No hi ha cap espai de treball Blockly",
  noFunctionsOnCanvas: "No hi ha funcions al llenç. Extreu a funció o carrega'n des de la biblioteca.",
  contribute: "Contribueix",
  loadCatalogBrowse: "Carrega el catàleg per explorar les funcions seleccionades.",
  catalogNoFunctions: "El catàleg no té funcions.",
  loadingLibrary: "Carregant la biblioteca de funcions…",
  fnReturnsValue: "{sig} → valor",
  pasteJsonFirst: "Enganxa primer el JSON de la IA (o un bloc intehrgrator-suggestions)",
  clipboardEmpty: "El porta-retalls és buit o no es pot llegir en aquest navegador",
  noMatches: "Cap coincidència",
  searchPlaceholder: "Cerca…",
  filterList: "Filtra la llista",
  historyTimeline: "Línia de temps de l'historial",
  historyIntro: "Arrossega per previsualitzar; la reversió talla les entrades posteriors. Desfer amb un pedaç retorna JSON intehrgrator-suggestions v2.",
  seqLabel: "Núm.",
  previewAtSeq: "Previsualitza al núm.",
  rollbackHere: "Reverteix fins aquí (destructiu)",
  copyPatchUndo: "Copia la indicació per desfer amb pedaç",
  timelineDesktopOnly: "La línia de temps de l'API de l'agent només està disponible a l'aplicació d'escriptori.",
  timelineUnavailable: "API de l'agent no disponible: la línia de temps està inactiva.",
  noHistoryYet: "Encara no hi ha historial.",
  selectHistoryPoint: "Selecciona un punt de l'historial.",
  downloadDiscardedConfirm: "Vols baixar la branca descartada (.intehrgrator) abans de continuar?",
  noBundleExport: "No hi ha dades de paquet per exportar de la branca descartada.",
  downloadedDiscarded: "S'ha baixat la branca descartada.",
  agentsHeading: "Agents",
  projectLoaded: "Projecte carregat",
  newProjectStatus: "Projecte nou",
  projectNotFound: "Projecte no trobat",
  projectImported: "Projecte importat",
  restoredMapping: "S'ha restaurat el mapatge anterior",
  blocklyMustBeObject: "El JSON de Blockly ha de ser un objecte",
  exampleDropJsonXml: "En deixar anar exemples: només fitxers JSON o XML",
  listeningSourceQuery: "Escoltant el camí d'origen → consulta d'origen",
  appliedDefaults: "Mapa de context per defecte aplicat",
  refreshPromptCopied: "S'ha copiat la indicació de fusió d'actualització",
  callingAi: "Cridant la IA…",
  providerRejectedTools: "El proveïdor ha rebutjat les eines de mapatge; es torna a provar amb JSON de suggeriments…",
  aiCredentialsCleared: "Credencials d'IA esborrades",
  aiCredentialsSaved: "Credencials d'IA desades en aquest navegador",
  saveAiOrCopy: "Desa les credencials d'IA per cridar la IA, o usa Copia la indicació.",
  loadTargetFirst: "Carrega primer una destinació a l'esquema de destinació i després aplica el mapa de context per defecte.",
  targetNodeMissing: "Aquest node de l'esquema de destinació no és a la destinació carregada.",
  dropLeafHint: "Deixa anar una fulla sobre les fitxes de destinació de bastida, un subarbre sobre un encaix de valor o sobre el llenç buit.",
  emptyMapReady: "Mapa de context per defecte buit a punt — arrossega des de l'esquema de destinació i després aplica.",
  pickTargetFirst: "Tria primer un fitxer o una URL de destinació.",
  corsCallAiHint: "El CORS del navegador sovint bloqueja els proveïdors al núvol des de GitHub Pages. Usa l'aplicació d'escriptori (reenvia Crida la IA), activa CORS en un servidor local (Ollama / LM Studio) o usa Copia la indicació.",
  savedAs: 'Desat com a "{name}"',
  loadedSchema: "Esquema {name} carregat",
  loadedBlockly: "Mapatge Blockly {name} carregat",
  loadedTargetIntoSchema: "Destinació {format} {id} carregada a l'esquema de destinació (encara sense bastida de producte)",
  loadedTarget: "Destinació {format} {id} carregada",
  loadedFunctionLibrary: "Biblioteca de funcions carregada ({n})",
  loadedFunction: "Funció {name} carregada",
  loadedExampleCatalog: "Catàleg de conjunts d'exemples carregat ({n} {sets})",
  setSingular: "conjunt",
  setPlural: "conjunts",
  loadedExampleSet: 'Conjunt d\'exemples "{name}" carregat',
  exampleSetFailed: 'El conjunt d\'exemples "{name}" ha fallat: {detail}',
  addedExample: "Exemple {name} afegit",
  addedExampleMismatch: "Exemple {name} afegit amb {n} {mismatch} d'esquema",
  mismatchSingular: "discrepància",
  mismatchPlural: "discrepàncies",
  addedExamples: "{n} exemples afegits",
  addedExamplesMismatch: "{n} exemples afegits amb {m} {mismatch} d'esquema",
  aiPromptCopied: "Indicació d'IA copiada ({delivery})",
  listeningSlot: "Escoltant el camí d'origen → {slot}",
  mappedWhat: "Mapat {what}",
  mappedSourceQuery: "Consulta d'origen {xpath} mapada",
  importSummary: "Importació: {applied} aplicats, {loops} bucles, {skipped} omesos, {errors} errors{schema}",
  importSchemaNote: ", {n} d'esquema",
  importFailed: "La importació ha fallat: {detail}",
  targetLoadFailed: "La càrrega de la destinació ha fallat: {detail}",
  exampleLoadFailed: "La càrrega de l'exemple ha fallat: {detail}",
  exampleFolderFailed: "La càrrega de la carpeta d'exemples ha fallat: {detail}",
  functionCatalogFailed: "El catàleg de la biblioteca de funcions ha fallat: {detail}",
  exampleCatalogFailed: "El catàleg de conjunts d'exemples ha fallat: {detail}",
  blocklyParseFailed: "No s'ha pogut analitzar el JSON de Blockly: {detail}",
  couldNotLoad: "No s'ha pogut carregar {name}: {detail}",
  autosaveFailed: "El desament automàtic ha fallat: {detail}",
  modelLanguageStatus: "Idioma del model: {language}",
  refreshedClean: "S'ha actualitzat {kind} {name} sense conflictes de mapatge.",
  refreshedWithWarnings: "S'ha actualitzat {kind} {previous} → {next}",
  warningCount: "{n} {warnings}:",
  warningSingular: "avís",
  warningPlural: "avisos",
  loadedGithubTemplate: "Plantilla de GitHub {id} carregada ({n} fitxers){extra}",
  loadedGithubSchema: "Esquema de GitHub {id} carregat ({n} fitxers){extra}",
  warningsParen: " ({n} avisos)",
  callAiFailed: "La crida a la IA ha fallat: {detail}",
  scaffoldTarget: "Destinació de bastida {path} (fes clic a la fitxa per commutar *.)",
  nestedOnMap: "{label} imbricat al mapa de context per defecte",
  addedMapEntry: "Entrada {key} ({path}) afegida a la fila {row}",
  addedFromTarget: "{label} afegit des de l'esquema de destinació",
  addedSource: "Origen {xpath} afegit",
  taskLoadGithub: "Carrega el model clínic des de GitHub",
  taskLoadAndScaffold: "Carrega la destinació i construeix l'esquelet",
  taskLoadExampleSet: "Carrega el conjunt d'exemples",
  taskLoadTarget: "Carrega la destinació",
  taskLoadSchema: "Carrega l'esquema d'origen",
  taskLoadMapping: "Carrega el mapatge",
  taskLoadSheets: "Carrega els fulls",
  taskLoadDefaults: "Carrega el mapa per defecte",
  taskParseUrl: "Analitza la URL de GitHub",
  taskIndexTree: "Llista els fitxers del repositori",
  taskFetchFiles: "Obtén els fitxers del model clínic",
  taskParseModels: "Analitza plantilles i arquetips",
  taskResolveOpt: "Resol la plantilla operativa",
  taskScaffold: "Construeix l'esquelet de plantilla",
  taskGenerate: "Genera el guió de conversió",
  taskLoadExampleN: "Carrega l'exemple {n}",
  appDescription: "intEHRgrator — banc de treball visual d'integració per mapar dades d'origen a openEHR",
  loadedColon: "Carregat: {name}",
  savedColon: "Desat: {name}",
  noMappingConflicts: "Sense conflictes de mapatge.",
  refreshReportLine: "{kind} {previous} → {next}",
  refreshWarningCount: "{n} avís(os):",
  hardcodedLookups: "S'ha fixat «{key}» a {n} {lookups}",
  lookupSingular: "cerca",
  lookupPlural: "cerques",
  noDefaultsLookups: "No hi ha cerques maps_get(\"defaults\", \"{key}\") al llenç",
  callAiResult: "Crida la IA: {applied} aplicats · {errors} errors{extra}",
  functionLibraryCount: "Biblioteca de funcions: {n} {functions}",
  functionSingular: "funció",
  functionPlural: "funcions",
  renamedFromParen: " (canvi de nom des de {name})",
  savedBundle: "Desat {name}",
  descriptionForFunction: "Descripció de la funció \"{name}\" (opcional):",
  clashExist: "{bits} ja existeixen. Canviar el nom conserva tots dos (per defecte). Substituir sobreescriu la definició existent.",
  functionQuoted: "Funció \"{name}\"",
  decisionQuoted: "Taula de decisió \"{name}\"",
  andWord: "i",
  openedContributionIssue: "Incidència de contribució oberta per a {name}",
  openedGithubForm: "Formulari de nova incidència de GitHub obert per a {name}",
  entrySummary: "{description} Paràmetres: {params}. Taules de decisió: {tables}.",
  recommendedFrozen: "Estàs usant intEHRgrator {current}, que no és la versió recomanada per a usuaris finals ({recommended}).",
  recommendedBleeding: "Estàs usant la compilació més recent (actualitzada amb cada canvi a main), no la versió estable recomanada ({recommended}).",
  goToRecommended: "Ves a la versió recomanada ({tag})",
  previewingSeq: "Previsualitzant el núm. {n}…",
  previewLoadedSeq: "Previsualització carregada per al núm. {n} (només de lectura; el llenç principal no canvia).",
  rollbackAsk: "Vols revertir al núm. {seq}?\n\nEs descartaran {n} entrades posteriors.\n\nVols baixar la branca descartada (.intehrgrator) abans de continuar?",
  confirmRollback: "Confirmes la reversió destructiva al núm. {seq}?",
  rolledBackSeq: "Revertit al núm. {n}. El llenç principal se sincronitzarà.",
  patchPromptCopied: "Indicació de pedaç copiada (intehrgrator-suggestions v2). Aplica-la amb import_suggestions.",
  optionalAttributes: "Atributs opcionals…",
  openViewerMenu: "Obre la finestra de visualització…",
  noAgentsYet: "Encara no hi ha agents connectats.",
  aiChatHistoryTrimmed: "S'han tret torns antics del xat perquè la petició quedi dins de {limit} tokens (l'API reenvia tot el xat a cada pas); aquest missatge torna a adjuntar el context del projecte.",
  aiChatHistoryFull: "No s'ha enviat res: l'historial del xat té uns {tokens} tokens, per sobre del límit de {limit} d'aquest model, i tot l'historial va amb cada petició. Com voleu continuar?",
  aiChatHistoryTrimChoice: "Continuar amb l'historial retallat",
  aiChatHistoryRecapChoice: "Començar un xat nou amb resum",
  aiChatHistoryCancelChoice: "Cancel·lar",
  aiChatHistoryRecapStarted: "Xat nou iniciat. Un resum del xat anterior (els vostres missatges, les respostes i els mapatges) va amb el vostre missatge, juntament amb el context del projecte.",
  aiChatHistoryCancelled: "No enviat. El vostre missatge encara és al quadre.",
  aiChatStorageTrimmed: "Aquest xat és més gran del que desa el navegador ({limit} caràcters). Aquesta pàgina conserva tot el xat, però en recarregar només queden els torns més recents.",
};
